<template>
  <div class="payment-wechat-page">
      <div v-if="payState == 0" class="text-center">
        <h1><i class="ico ico-wechatpay"></i>&nbsp;请扫码完成微信支付</h1>
        <p style="padding:40px 0 10px;color:#888;font-size: 18px;">付款金额</p>
        <p style="font-size: 36px;color: #333;">{{amount|currency('¥')}}</p>
        <img width="220" :src="url" />
      </div>
      <div v-if="payState != 0" class="text-center redirct">
        <p><i class="ico ico-paysucces"></i></p>
        <h1 style="padding: 60px 0 25px;">支付完成</h1>
        <!-- <p v-if="order.fee_adjustment_list.length == 0">{{seconds}}秒后</p> -->
        <p v-if="order.fee_adjustment_list.length == 0">正在跳转任务发布成功页面~</p>
        <!-- <p v-if="order.fee_adjustment_list.length >0">{{seconds}}秒后关闭该窗口</p> -->
        
      </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import { API_HOST } from '../../services/constant.js'
import os from '../../services/checkOs.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['id', 'amount','orderNo','order','type'],
  components: {
  },
  computed: {
  },
  data () {
    return {
      API_HOST: API_HOST,
      url: null,
      payState: 0,
      seconds: 5,
      checkPaidStatusInterval: null,
      redirctTimer: null
    }
  },
  created () {
    let payPath;
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
      payPath = 'pay/wechat_mobile/index.php'
    } else if(os.isAndroid || os.isPhone){
      payPath = 'pay/wechat_mobile_other/index.php'
    } else {
      if(this.type ==11)
        payPath = 'pay/alphapay/qr_code.php?channel=Wechat&currency=CNY'
      else
        payPath = 'pay/wechat/index.php'
    }
    if(this.order.fee_adjustment_list.length == 0){
      if(this.type==11){
        this.url = this.API_HOST + '/' + payPath + '&id=' + this.id+'&token=' + this.$localStorage.get('token')
      }
      else
        this.url = this.API_HOST + '/' + payPath + '?id=' + this.id + '&token=' + this.$localStorage.get('token')
      //this.url = this.API_HOST + '/'+payPath+'?id=' + this.id + '&token=' + this.$localStorage.get('token')
    }
    if(this.order.fee_adjustment_list.length > 0){
      this.url = this.API_HOST + '/'+payPath+'?fee_adjustment_id=' + this.order.fee_adjustment_list[0].id + '&token=' + this.$localStorage.get('token')
    }
    if (/micromessenger/.test(navigator.userAgent.toLowerCase()) || os.isAndroid || os.isPhone) {
      window.location.href = this.url
      // return
    }

    this.checkPaidStatus()
    this.checkPaidStatusInterval = setInterval(() => {
      this.checkPaidStatus()
    }, 2000)
  },
  methods: {
    async checkPaidStatus () {
      console.log(this.id)
      try {
          if(this.order.fee_adjustment_list.length == 0){
              let res = await api.checkPaidStatus(this, {
                order_id: this.id,
                login_dialog: true
              })
              this.payState = res.body.result || 0
              
          }
          if(this.order.fee_adjustment_list.length > 0){
              api.post(this, {
                path: 'order.php',
                api: 'check_paid_status_when_adjust_fee',
                data: {fee_adjustment_id: this.order.fee_adjustment_list[0].id}
              }).then((res) => {
                let body = res.body
                if(body.status === "ok"){
                  console.log(body.result)
                  this.payState = body.result || 0
                }
              },(err) => {
                this.loading = false
              })
          }
          if (this.payState != 0) {
            clearInterval(this.checkPaidStatusInterval)
            this.redirctTimer = setInterval(() => {
              // this.seconds --
                this.$emit('close')
                clearInterval(this.redirctTimer)
                if(this.$route.path == '/customer/task/list'){
                  this.$router.go(0)
                }else{
                  this.$router.push({ path: '/Complete',query: {order_id:this.id} })
                }
            },10)
          }
      } catch(e) {
        clearInterval(this.checkPaidStatusInterval)
        this.$emit('close')
        console.warn(e)
      }
    }
  },
  beforeDestroy: function() {
      clearInterval(this.checkPaidStatusInterval)
      clearInterval(this.redirctTimer)
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.payment-wechat-page {
  padding-bottom: 60px;
}
h1 {
  text-align: center;
  font-size:24px;
  color:rgba(51,51,51,1);
  line-height:33px;
}
img {
  margin-top: 20px;
  border: 1px solid #DEE2EC;
  width: 220px;
  height: 220px;
}
.redirct {
  font-size:24px;
  font-family:PingFangSC-Regular;
  line-height:33px;
  margin-top: 54px;
  padding-bottom: 70px;

  a {
    font-size: 16px;
  }

  p {
    line-height: 24px;
    color: #888
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/Wechat.vue